import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, BarChart3 } from "lucide-react";
import { formations } from "@/data/formations";

export default function FormationsGrid({ compact = false }) {
  return (
    <section className="bg-brand-surface py-14 md:py-20" data-testid="formations-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-12">
          <div className="max-w-3xl">
            <div className="overline">Catalogue 2026 · 2027</div>
            <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl mt-3 text-brand-ink leading-[1.05]">
              Quatre parcours pour devenir <span className="text-brand-blue">opérationnel sur l'IA.</span>
            </h2>
            <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
              Du débutant au niveau avancé, chaque formation est construite autour de cas d'usage réels et d'un projet appliqué à votre métier.
            </p>
          </div>
          {!compact && (
            <Link to="/contact" className="btn-cta self-start md:self-end" data-testid="formations-cta">
              Demander un devis
              <ArrowUpRight className="w-5 h-5" />
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {formations.map((f) => (
            <Link
              key={f.slug}
              to={`/formations/${f.slug}`}
              className="group relative bg-white border border-brand-line hover:border-brand-ink transition-all duration-300 flex flex-col overflow-hidden"
              data-testid={`formation-card-${f.slug}`}
            >
              {/* Illustration block — dark navy frame to match illustration backgrounds */}
              <div className="relative aspect-[16/9] overflow-hidden bg-[#0a1830]">
                <img
                  src={f.image}
                  alt={f.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 flex items-center gap-2 text-white">
                  <span className="font-heading font-black text-sm tracking-[0.2em] text-brand-cta">
                    {f.number}
                  </span>
                  <span className="h-px w-8 bg-white/30" />
                  <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/80">{f.level}</span>
                </div>
                <div className="absolute top-4 right-4 w-9 h-9 bg-white/0 border border-white/20 group-hover:bg-brand-cta group-hover:border-brand-cta flex items-center justify-center transition-all">
                  <ArrowUpRight className="w-4 h-4 text-white group-hover:rotate-45 transition-transform duration-300" />
                </div>
              </div>

              <div className="p-7 md:p-8 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-2xl md:text-[1.7rem] leading-[1.15] tracking-tight text-brand-ink group-hover:text-brand-blue transition-colors">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed flex-1">
                  {f.tagline}
                </p>
                <div className="mt-6 pt-5 border-t border-brand-line flex flex-wrap items-center gap-4 text-xs">
                  <span className="inline-flex items-center gap-1.5 font-semibold text-brand-ink">
                    <Clock className="w-3.5 h-3.5 text-brand-blue" />
                    {f.duration}
                  </span>
                  <span className="inline-flex items-center gap-1.5 font-semibold text-brand-ink">
                    <BarChart3 className="w-3.5 h-3.5 text-brand-blue" />
                    {f.level}
                  </span>
                  <span className="ml-auto text-brand-blue font-bold inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Voir le programme <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
